import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ListClienteComercioComponent} from './list-cliente-comercio/list-cliente-comercio.component';

const routes: Routes = [
  {
    path: '',
    component: ListClienteComercioComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClienteComercioRoutingModule { }
